import {debounce} from 'lodash';

require('waypoints/lib/noframework.waypoints.js');
require('waypoints/lib/shortcuts/inview.js');

$(function () {
    let oldScroll = $(window).scrollTop();
    let didScroll = false;
    let prevScrollpos = window.pageYOffset;

    /* scroll event to hide display top bar nav*/
    function scrollCallback() {
        // console.log('scroll callback');
        const $navbar = $('#sticky-header');
        const currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 100) {
            if (prevScrollpos >= currentScrollPos) {
                $navbar.addClass("reveal");
            } else {
                $navbar.removeClass("reveal");
            }
        } else if (currentScrollPos <= 100) {
            setTimeout(function () {
                $navbar.removeClass("reveal");
            }, 150);
        }
        prevScrollpos = currentScrollPos;
    }

    $(window).on('scroll', _.throttle(scrollCallback, 200, {leading: true}));

    /* create item chapter tracker */
    let index = 0;
    $('.chapter, .page-hero').each(function () {
        const $this = $(this);
        const $chapterTracker = $('.chapter-tracker');
        const $nav = $('#narrow-nav .chapter-nav');

        $this.attr('data-index', index);

        const inview = new Waypoint.Inview({
            element: $this[0],
            enter  : function (direction) {
                // console.log($this.attr('data-title'));
                $chapterTracker.find('.title').text($this.attr('data-title'));
                $chapterTracker.find('.number .current').text($this.attr('data-index'));
                history.pushState(null, null, $this.attr('data-slug'));

                updateShareLink();

                /* change nav state */
                $(`#narrow-nav .chapter-item`).removeClass('current');
                $(`#narrow-nav .chapter-item[href="${$this.attr('data-slug')}"]`).addClass('current');
            },
            // offset : '75%',
        });

        /* add item to chapter nav */
        $nav.append(`
            <a class="chapter-item" data-index="${$this.attr('data-index')}" href="${$this.attr('data-slug')}">
                <div class="bullet-point"></div>
                <div class="content">
                    <label class="current">CHAPTER ${$this.attr('data-index')}</label>
                    <h4 class="title">
                        ${$this.attr('data-title')}
                    </h4>
                </div>
            </a>
        `);

        index++;
    });

    /* update share link on share-button */
    function updateShareLink() {
        /* change share button url */
        // https://www.facebook.com/sharer/sharer.php?u=
        // https://twitter.com/intent/tweet?url=
        // https://www.linkedin.com/sharing/share-offsite/?url=

        const placeholderText = $('meta[name=share-placeholder-text]').prop('content');
        $('#share-button-container a').each(function () {
            let linkTemplate = '';
            if ($(this).hasClass('facebook')) {
                linkTemplate = 'https://www.facebook.com/sharer/sharer.php?u=';
            } else if ($(this).hasClass('twitter')) {
                linkTemplate = 'https://twitter.com/intent/tweet?text=' + placeholderText + '&url=';
            } else if ($(this).hasClass('linkedin')) {
                linkTemplate = 'https://www.linkedin.com/sharing/share-offsite/?url=';
            }
            $(this).attr('href', linkTemplate + '' + encodeURIComponent(window.location.href));
        })
    }

    /* toggle open/close nav menu */
    $('#menu-toggler-button, .menu-toggler-button, .chapter-tracker, #menu-close-button, #narrow-nav .chapter-item').click(function () {
        if ($('body').hasClass('menu-open')) {
            $('body').toggleClass('menu-open');

            $('html, #sticky-header .menu-toggler').css('margin-right', '');
            $('#main-header .menu-toggler-container').css('right', '');

            $('#narrow-nav').toggleClass('open');
        } else {
            //setTimeout(function () {
                $('body').toggleClass('menu-open');
            //}, 400);

            $('html, #sticky-header .menu-toggler').css('margin-right', '15px');
            $('#main-header .menu-toggler-container').css('right', '27px');

            $('#narrow-nav').toggleClass('open');
        }
    });

    /* toggle open/close nav menu on chapter tracker */
    // $(document).on('click', '#narrow-nav .chapter-item, #menu-close-button', function () {
    //     $('#narrow-nav').removeClass('open');
    //     $('body').removeClass('menu-open');
    // });
})
